/**
 * Google Tag Manager helpers.
 *
 * Backyard is a single page application, so GTM only ever sees one real page
 * load. Every route change after that is reported by pushPageView.
 */

/**
 * Routes whose query string is not reported. `/reset-password?token=…&email=…`
 * carries the password reset token and the user's email address.
 *
 * Everywhere else the query string is reported, so search terms and the like
 * end up in GA4.
 */
const WITHOUT_QUERY = ['/reset-password'];

/**
 * @param string pathname
 */
export function normalizePath(pathname) {
	if (typeof pathname !== 'string' || pathname === '') return '/';

	return pathname;
}

/**
 * The query string to report for a path, if any.
 *
 * The path is lower cased and its trailing slash removed before it is compared,
 * because react-router matches routes case insensitively and ignores a trailing
 * slash. `/Reset-Password/?token=…` renders the same page, so it has to be
 * caught here too.
 *
 * @param string pathname
 * @param string search
 */
export function normalizeSearch(pathname, search) {
	if (typeof search !== 'string' || search === '') return '';

	const route = String(pathname)
		.toLowerCase()
		.replace(/\/+$/, '');

	return WITHOUT_QUERY.indexOf(route) === -1 ? search : '';
}

/**
 * Report a route change to GTM.
 *
 * Bromma's container needs a trigger on the custom event `spa_pageview`.
 *
 * @param object location  react-router location
 */
export function pushPageView(location) {
	if (!window.dataLayer || !location) return;

	const path = normalizePath(location.pathname);
	const url = path + normalizeSearch(path, location.search);

	window.dataLayer.push({
		event: 'spa_pageview',
		page_path: url,
		page_location: window.location.origin + url,
	});
}



// WEBPACK FOOTER //
// ./src/analytics.js